export default "__VITE_ASSET__rdq6b7rK__"